/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-showmore.scss'
import template from 'lui-showmore.html'

export default class LuiShowmore extends LuiBase {
  static get is() {
    return 'lui-showmore'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  static get cssClassToggles() {
    return ['left', 'disabled']
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  disabledChanged() {
    this.classList[this.hasAttribute('disabled') ? 'add' : 'remove']('lui-disabled')
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-showmore/lui-showmore.js
// module id = 310
// module chunks = 0 1 38